<ng-container *ngIf="variant === 'kp'; else defaultVariant">
  <label class="kp-input">
    <span *ngIf="label" class="kp-input__label" [class.kp-input__label--required]="required">{{ label }}</span>
    <input
      class="kp-input__input"
      [attr.name]="name"
      [attr.placeholder]="placeholder"
      [maxlength]="maxlength"
      [formControl]="control"
      [required]="required"
      (keydown)="onKeyDown($event)"
    />
    <span
      *ngIf="validationMessage && control.invalid && control.dirty"
      class="kp-input__error body-xs"
      data-cy="input-field-error"
    >
      {{ validationMessage }}
    </span>
  </label>
</ng-container>
<ng-template #defaultVariant>
  <mat-form-field [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [name]="name"
      [placeholder]="placeholder"
      [maxlength]="maxlength"
      [formControl]="control"
      [required]="required"
      (keydown)="onKeyDown($event)"
    />
  </mat-form-field>
</ng-template>
